// extracted by css-extract-rspack-plugin
export default {"input":"input-Rv85_o","label":"label-tPuPDx"};